export class EIOPAError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'EIOPAError';
    }
}